import type { ProviderFragment } from "../../../../types";

const sortProvidersByName = (
  providers: ProviderFragment[],
): ProviderFragment[] =>
  providers.slice().sort((a, b) => (a.name || "").localeCompare(b.name || ""));

export default sortProvidersByName;
